/**
 * Copyright 2020 The Ground Authors.
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatListModule} from '@angular/material/list';
import {BrowserModule} from '@angular/platform-browser';

import {JobListItemModule} from 'app/components/job-list-item/job-list-item.module';
import {GroundIconModule} from 'app/modules/ground-icon.module';

import {JobListComponent} from './job-list.component';

@NgModule({
  imports: [
    BrowserModule,
    MatListModule,
    JobListItemModule,
    MatButtonModule,
    GroundIconModule,
  ],
  exports: [JobListComponent],
  declarations: [JobListComponent],
})
export class JobListModule {}
